<template>
  <nx-bform-group :label="requiredLabel(name)" v-bind="$attrs">
    <nx-bform-file
      :name="name"
      :rules="{ required }"
      :value="$attrs.value"
      @input="$listeners.input"
      :placeholder="name"
    />
  </nx-bform-group>
</template>

<script>
import FormGroupMixin from "../form-group.mixin";

export default {
  mixins: [FormGroupMixin],
  computed: {
    name() {
      return this.label || this.$t("esign");
    }
  }
};
</script>

<i18n src="@/locales/registration.locale.json" />
